import React from "react";
import { groupBy } from "lodash";
import SideNavItem from "factory/sidenav/components/SideNavItem";
import AddonsSideNavItem from "factory/sidenav/components/AddonsSideNavItem";
import SideNavContent from "factory/sidenav/components/SideNavContent";
import Auth from "Auth";
import { useQuery } from "@apollo/client/react";

import { AVAILABLE_ANALYTICS } from "../../graphql";

interface AnalyticsItem {
  id: string;
  name: string;
  group: string;
}

interface AvailableAnalyticsData {
  availableAnalytics: AnalyticsItem[];
}

interface AvailableAnalyticsVars {
  clientId: string;
  userId: string;
}

export interface SideNavProps {
  path: string;
}

const SideNav: React.FC<SideNavProps> = ({ path }) => {
  const isAdmin = Auth.isAdmin();

  const { loading, data } = useQuery<AvailableAnalyticsData, AvailableAnalyticsVars>(
    AVAILABLE_ANALYTICS,
    {
      variables: {
        clientId: String(Auth.getJWT().clientId),
        userId: String(Auth.getJWT().id),
      },
    }
  );

  const analytics = data?.availableAnalytics || [];
  const groups = groupBy(analytics, "group");

  return (
    <div>
      <ul className="navigation navigation--light">
        <AddonsSideNavItem />
      </ul>
      <SideNavContent path={path}>
        {!loading &&
          Object.keys(groups).map((key) => {
            const items = groups[key];

            return (
              <SideNavItem
                key={`dashboard-group-item-${key}`}
                labelWithoutTranslation={key}
                icon="Dashboard"
                link={`/dashboard/${key.toLowerCase()}`}
                submenuIcon="Dashboard"
                submenuLevelCheck={2}
                submenuLabelWithoutTranslation={key}
              >
                <ul className="navigation">
                  {items.map((item) => (
                    <SideNavItem
                      key={`dashboard-item-${item.id}`}
                      labelWithoutTranslation={item.name}
                      link={`/dashboard/${key.toLowerCase()}/${item.id}`}
                      icon="Dots"
                    />
                  ))}
                </ul>
              </SideNavItem>
            );
          })}

        {isAdmin && (
          <SideNavItem
            submenuIcon="Cog"
            submenuLabel="administration"
            label="administration"
            link="/settings"
            icon="Cog"
          >
            <ul className="navigation">
              <SideNavItem
                label="flexiBi.users.title"
                link="/settings/users"
                icon="person"
              />
            </ul>
          </SideNavItem>
        )}
      </SideNavContent>
    </div>
  );
};

export default SideNav;
